import { useCallback } from 'react';
import { DragEndEvent } from '@dnd-kit/core/dist/types';
import { arrayMove } from '@dnd-kit/sortable';

import { ParticipantDto, Tournament, TournamentTeam } from '@features/shared/api/typings';

export function useOnDragEnd(
  tournament: Tournament,
  onRearrangeParticipants?: (participants: ParticipantDto[]) => void,
  onRearrangeTeams?: (teams: TournamentTeam[]) => void,
  participants?: ParticipantDto[],
) {
  return useCallback(
    (dragEvent: DragEndEvent) => {
      const { active, over } = dragEvent;

      if (!participants || !onRearrangeParticipants || !onRearrangeTeams || !over || !active)
        return;
      if (active.id === over.id || over.disabled) return;

      if (
        tournament.teams &&
        active.data.current?.type === 'team' &&
        over.data.current?.type === 'team'
      ) {
        const oldIdx = tournament.teams.findIndex((t) => t.teamId === active.data.current!.teamId);
        const newIdx = tournament.teams.findIndex((t) => t.teamId === over.data.current!.teamId);
        const newTeams = arrayMove(tournament.teams, oldIdx, newIdx);
        onRearrangeTeams(newTeams);
      }
    },
    [tournament.teams, participants, onRearrangeParticipants, onRearrangeTeams],
  );
}
